import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

function normalizeDomain(domain = ""): string {
  return domain
    .trim()
    .replace(/^https?:\/\//, "")
    .replace(/\/+$/, "");
}

export const materialSecurity = defineConnector({
  identifier: "materialSecurity",
  name: "Material Security",
  tagLine: "Email security and data protection for cloud workspaces",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ domain }) => domainToRegex(normalizeDomain(domain)),
  auth: (app) =>
    headerAuth([
      { name: "x-material-client-secret", value: app.secret.apiKey },
    ]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to [Material Security](https://material.security/), open **Platform → API Reference**, and select **Create Token**.",
        },
      ],
    },
    {
      title: "Enter your Material Security details",
      items: [
        {
          kind: "input",
          label: "Material Security API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "Domain",
          required: true,
          target: { kind: "configuration", field: "domain" },
          placeholder: "your-tenant.on.material.security",
          helperText:
            "From the API Reference curl example, enter the text after https:// and before /api/.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => ({
      url: `https://${normalizeDomain(domain)}/api/beta/unity/issues/list`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ limit: 1 }),
    }),
  },
});
